module.exports = __webpack_public_path__ + "static/media/order-white.a6a1a1e6.svg";